// eslint-disable-next-line no-unused-vars
type Func = (...args: unknown[]) => unknown;

export const throttle = (fn: Func, wait: number): Func => {
  let previouslyRun: number;
  let queuedToRun: number;

  return function invokeFn(...args: unknown[]) {
    const now = Date.now();

    if (queuedToRun) {
      clearTimeout(queuedToRun);
    }

    if (!previouslyRun || now - previouslyRun >= wait) {
      fn(...args);
      previouslyRun = now;
    } else {
      queuedToRun = window.setTimeout(invokeFn.bind(null, ...args), wait - (now - previouslyRun));
    }
  };
};
